const state = [
  'running',
  'after',
  'before'
]

module.exports = {
  state
}
